import React from 'react';
import Container from '@Theme/natucare/components/Container/Container';
import Icon from '@Theme/natucare/components/Icon/Icon';
import Picture from '@Theme/natucare/components/Picture/Picture';
import Cta from './components/Cta/Cta';
import { mediaSocialPropTypes } from './MediaSocialPropTypes';
import * as styles from './MediaSocial.module.scss';
const MediaSocial = ({
  heading,
  items,
  socials,
  cta
}) => {
  if (!heading && !items) {
    return null;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: `${styles.root} ${styles.rootWave} ${styles.rootWhite}`
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, heading && /*#__PURE__*/React.createElement("h2", {
    className: styles.rootHeading,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), socials && /*#__PURE__*/React.createElement("div", {
    className: styles.rootSocials
  }, socials.map(({
    icon,
    label,
    href
  }, index) => /*#__PURE__*/React.createElement("a", {
    className: styles.rootSocial,
    href: href,
    key: index,
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Icon, {
    path: icon === null || icon === void 0 ? void 0 : icon.path,
    viewBox: icon === null || icon === void 0 ? void 0 : icon.viewBox,
    classname: styles.rootSocialIcon
  }), " ", label))), items && /*#__PURE__*/React.createElement("div", {
    className: styles.rootItems
  }, items.map(({
    picture
  }, index) => /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: picture.xs
    },
    pictureClassname: styles.rootItemPicture,
    imgClassname: styles.rootItemImage,
    alt: picture === null || picture === void 0 ? void 0 : picture.alt,
    key: index
  })), cta && /*#__PURE__*/React.createElement(Cta, cta))));
};
export default MediaSocial;